import * as React from 'react'
import { ModalTrigger } from '../../utils/ModalTrigger'
import { DropList, IconType, PrimeButton } from 'DVWebNodeUI'
import { LinkProps } from '../../../../dvui/components/Link/Link'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import * as st from './feedbackForm.module.scss'
import { Logger, constructQueryString } from '@utils'
import { popupWindowParams } from '../../utils/utils'
import { RecordRefTag } from '../recordReftag/recordReftag'

const DROPLIST_PREFIX = 'av-droplist-'
const TARGET_WINDOW_WIDTH = 500
const TARGET_WINDOW_HEIGHT = 540

export interface FormParams {
  ASIN: string,
  deviceName: string,
  deviceTypeId: string,
  encryptedCustomerId: string,
  recordTerritory: string,
  currentTerritory: string,
  language: string,
  marketplace: string,
  playerSource: string,
  returnUrl: string,
  sourceUrl: string,
  sessionId: string,
}

interface elemDOM extends HTMLElement {
  checked: boolean
}

export interface FeedbackFormModalContentProps {
  dropListId: string,
  dropListLinks: LinkProps[],
  logger: Logger,
  formUrl: string,
  formParams: FormParams,
  formOnSubmitFn?: () => void,
}

export const FeedbackFormModalContent = ({
  dropListId,
  dropListLinks,
  logger,
  formUrl,
  formParams,
  formOnSubmitFn,
}: FeedbackFormModalContentProps) => {
  // todo: ask for a toggle api of dvui dropList component and then remove this
  const links = dropListLinks.map(dropListLink => ({
    ...dropListLink,
    onClick : (e: React.MouseEvent<HTMLElement>) => {
      const el = document.getElementById(`${DROPLIST_PREFIX}${dropListId}`) as elemDOM
      if (el && el.checked) {
        // set false to toggle off the drop list
        el.checked = false
      }
      dropListLink.onClick(e)
    },
  }))

  const submit = () => {
    formOnSubmitFn && formOnSubmitFn()
    window.open(
      formUrl + constructQueryString(logger, formParams),
      '_blank',
      popupWindowParams(TARGET_WINDOW_WIDTH, TARGET_WINDOW_HEIGHT)
    )
  }

  return (
    <>
      <h4 className={`${st.feedbackQuestion}`}>
        <TextLocalizer stringID={StringId.DV_WEB_FEEDBACK_select_related_device}/>
      </h4>
      <div className={`${st.feedbackFormDropList}`} data-automation-id="feedback-drop-list"
           data-testid="feedback-drop-list">
        <DropList links={links} customDropListID={dropListId}/>
      </div>
      <PrimeButton useIcon={IconType.EXTERNAL} onClick={submit} className={`${st.feedbackFormContinue}`}
                   data-automation-id="feedback-submit-button" data-testid="feedback-submit-button">
        <TextLocalizer stringID={StringId.DV_WEB_FEEDBACK_submit_button}/>
      </PrimeButton>
    </>
  )
}

interface FeedbackFormModalProps {
  isOpen: boolean,
  link: React.ReactNode,
  linkOnClickFn: () => void,
  onCloseFn: () => void,
  header: React.ReactNode,
  children: React.ReactNode,
}

export const FeedbackFormModal = ({
  isOpen = false,
  link,
  linkOnClickFn,
  onCloseFn,
  header,
  children
}: FeedbackFormModalProps) => (
  <ModalTrigger
    isOpen={isOpen}
    toggle={() => (
      // todo: support core experience if survey page supports
      <RecordRefTag refTag={"atv_dp_fb_open"}>
        <button data-automation-id="feedback-button" data-testid="feedback-button" className={`${st.feedbackLink}`}
                onClick={linkOnClickFn}>
          {link}
        </button>
      </RecordRefTag>
    )}
    onClose={onCloseFn}
    modalHeader={<span className={`${st.feedbackFormHeader}`}>{header}</span>}
    modalContent={children as React.ReactChild}
    className={`${st.feedbackFormModal}`}
  />
)
